module.exports = __webpack_public_path__ + "static/media/corner-down.287c48d9.svg";